import { limit } from 'app/core/factory-yup';
import i18next from 'i18next';

import { ObjectRequired, StringRequired } from '../../../../core/validations/common';

import { type TaxpayerFieldValidationRule } from './index';
import { RequiredForBusiness } from './val-request-common';

const url = '(?:https?:\\/\\/)?[a-z0-9]+(?:[-.][a-z0-9]+)*\\.[a-z]{2,5}(?::\\d{1,5})?(?:\\/.*)?';

const websitesRegex = new RegExp(`^${url}(?:\\s*,\\s*${url})*$`, 'i');

export const rulesGeneralData: Array<TaxpayerFieldValidationRule> = [
  {
    validation: {
      personType: ObjectRequired,
      taxpayerName: StringRequired.max(limit.maxName),
      country: ObjectRequired
    }
  },
  {
    field: 'tradeName',
    validation: {
      tradeName: RequiredForBusiness.max(limit.maxName)
    }
  },
  {
    field: 'politicalDivision',
    validation: {
      politicalDivision: ObjectRequired
    }
  },
  {
    field: 'address',
    validation: {
      address: StringRequired.max(500)
    }
  },
  {
    field: 'city',
    validation: {
      city: StringRequired.max(limit.maxName)
    }
  },
  {
    field: 'zipCode',
    validation: {
      zipCode: StringRequired.max(limit.maxName)
    }
  },
  {
    field: 'website',
    validation: {
      website: StringRequired.matches(websitesRegex, () =>
        i18next.t('common.validations.urlInvalid')
      ).max(limit.maxName)
    }
  }
];
